export default "__VITE_ASSET__BTF5hqVn__"